import { useState, useEffect } from 'react';
import { ScMaxCapModal, ScMaxCapNotification } from './ScMaxCapModal';
import { useAuth } from '@/contexts/AuthContext';
import { websocketClient } from '@/lib/websocket-client';

export const GlobalScMaxCapModal = () => {
  const { user } = useAuth();
  const [notification, setNotification] = useState<ScMaxCapNotification | null>(null);

  // Use user object instead of isAuthenticated to ensure we have a valid user
  // isAuthenticated can be undefined initially, but user will be null or an object
  const isLoggedIn = !!user;

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    const handleScMaxCap = (data: ScMaxCapNotification) => {
      setNotification(data);
    };

    const unsubscribe = websocketClient.subscribe('sc_max_cap:applied', handleScMaxCap);

    return () => {
      unsubscribe();
    };
  }, [isLoggedIn, user?.email]);

  const handleClose = () => {
    setNotification(null);
  };

  return (
    <ScMaxCapModal 
      notification={notification}
      onClose={handleClose}
      refreshOnClose={true}
    />
  );
};
